<template>
  <div style="height: 110vh;width: 100%;" v-loading="loading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <div style="padding: 10px;margin-top: -1%">

      <div>
        <el-card style="border-radius: 8px">
          <div style="width: 100%;display:inline-flex;">
            <div style="width: 5%">
              <span>
                <i class="el-icon-message-solid" style="font-size: 23px;color: rgba(27,94,234,0.74);"></i>
              </span>
            </div>
              <div @click="noticeVisible=true" style="width: 90%;font-size: 15px;color: #1b5eea;
          white-space: nowrap;overflow: hidden;text-overflow: ellipsis;padding-top: 2px;">
                <span>标题：{{notice.title}}</span>
                <span style="margin-left: 2%">{{notice.createTime}}</span>
                <span style="margin-left: 2%">{{notice.content}}</span>
              </div>
            <div style="width: 5%;">
              <i @click="noticeDataBox=true" class="el-icon-s-order" style="font-size: 25px;float: right"></i>
            </div>

          </div>

        </el-card>
      </div>

      <div style="margin-top: 1%">
        <p style="font-size: 16px;font-weight: lighter">快捷入口</p>
      </div>

      <div>
        <el-row :gutter="12">
          <el-col  v-for="(item,index) in quickList" :key="index" :span="4">
            <el-card @click.native="goPath(item)" :body-style="{ padding: '30px',borderRadius:'8px' }" shadow="always">
              <div style="display: inline-flex;justify-content: space-around;width: 100%">
                <span style="font-size: 16px;padding-top: 8px">{{item.name}}</span>
                <!--<img src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png" style="width: 40px;height: 40px">-->
                <i :class="item.icon" style="font-size: 40px;color: rgba(27,94,234,0.74);"></i>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div style="margin-top: 1%">
        <p style="font-size: 16px;font-weight: lighter">线上数据统计</p>
      </div>

        <div>
          <el-row :gutter="12">
            <el-col  v-for="(item,index) in dataList" :key="index" :span="4">
              <el-card @click.native="goPath(item)"  shadow="always">
                <div class="dot" style="display: inline-flex;justify-content: space-around;width: 100%">
                  <p style="font-size: 16px;padding-top: 8px">{{item.name}}</p>
                  <p style="font-size: 16px;padding-top: 8px;font-weight:300">{{item.count===undefined?0:item.count}}</p>
                </div>
              </el-card>
            </el-col>
          </el-row>

        </div>
      <div style="margin-top: 1%">
        <p style="font-size: 16px;font-weight: lighter">在网时长分析</p>
      </div>

        <div style="justify-content: space-between;display: inline-flex;width: 100%;">
          <el-card style="width: 49.8%;border-radius: 8px">
            <div style="width: 100%;display: grid">
              <span style="font-weight: 300;font-size: 15px;text-align: center">线上套餐订购年占比</span>
            </div>
            <el-table :data="find_zwList" :row-style="{height:'45px',textAlign:'center'}" :cell-style="{height:'5px,0',textAlign:'center'}" :header-cell-style="{background: 'rgba(98, 101, 102, 0.28)', color: 'rgb(15, 15, 15)',textAlign:'center'}" border style="width: 100%;" >
              <el-table-column prop="countNumTM"  label="总用户" show-overflow-tooltip ></el-table-column>
              <el-table-column prop="packetName"  label="套餐规格" show-overflow-tooltip></el-table-column>
              <el-table-column prop="countNumTM_zw"  label="在网用户" show-overflow-tooltip></el-table-column>
              <el-table-column prop="countNumTM_zb"  label="在网占比" show-overflow-tooltip></el-table-column>
            </el-table>
            <div style="width: 100%;display: grid">
              <span style="font-weight: 300;font-size: 15px;text-align: center">环图统计</span>
            </div>
            <el-card style="border-radius: 8px;">
              <div style="width: 100%">
                <dv-active-ring-chart :config="averageFlowList" style="padding-top: 10%;width: 250px;height: 200px;margin: 0 auto"  />
                <div style="text-align: center;">
                  <span style="font-size: 16px;font-weight: 300;color: black">年用量</span>
                </div>

              </div>
            </el-card>
          </el-card>

          <el-card style="width: 49.8%;border-radius: 8px">
            <div style="width: 100%;display: grid">
              <span style="font-size: 15px;line-height: 1.5em;text-align: center;font-weight: 300">线上使用在网月占比</span>
            </div>
            <el-table :data="countNumTM_useFlow" :row-style="{height:'45px',textAlign:'center'}" :cell-style="{height:'5px,0',textAlign:'center'}" :header-cell-style="{background: 'rgba(98, 101, 102, 0.28)', color: 'rgb(15, 15, 15)',textAlign:'center'}" border style="width: 100%;" >
              <el-table-column prop="monthNum"  label="在网月数" show-overflow-tooltip ></el-table-column>
              <el-table-column prop="flg" label="在网用户" show-overflow-tooltip></el-table-column>
              <el-table-column prop="countNumTM_zb"  label="在网占比" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-card>

        </div>


    </div>

    <el-dialog title="系统公告" :visible.sync="noticeDataBox" width="40%"
               class="class_dialog_hospital">
      <el-table
              :row-style="{height:'40px'}"
              :cell-style="{height:'5px,0',textAlign:'center'}"
              :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
              :data="noticeData"
              style="">
        <el-table-column
                prop="createTime"
                label="日期"
                width="180">
        </el-table-column>
        <el-table-column
                prop="title"
                label="标题"
                width="300">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
                    size="mini"
                    @click="selectNotice(scope.row)">内容</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="系统公告" :visible.sync="noticeVisible" width="40%"
               class="class_dialog_hospital">
      <div style="color:black;font-weight: 900;font-size: 16px;margin-bottom: 3px;">【{{notice.title}}】</div>
      <div style="font-size: 14px;margin-left: 10px;">发布日期：{{notice.createTime}}</div>
      <div style="margin-top: 2%;margin-bottom: 20px;margin-left: 20px; color: #1b5eea;font-size: 16px;">
        {{notice.content}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="noticeVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import tools from '../../utils/tools'
  import { delComma } from '../../utils/delComma'
  import * as echarts from 'echarts'
  import {aesEncrypt,aesDecrypt} from '../../utils/mycrypto'


  export default {
    name: 'welcome2',
    data() {
      return {
        loading: false,
        noticeDataBox:false,
        noticeData:[],
        notice: {},
        noticeVisible: false,
        refreshTimer: sessionStorage.getItem("refreshTimer"),
        find_agentCount:0,
        find_routeCount:0,
        find_usedFlow:0.00,
        find_zwList:[],
        countNumTM_useFlow:[],
        Chatlist: [],
        loginUser: {},
        map: {
          startTime: '',
          endTime: '',
          agentId: '',
        },
        drawer: false,
        find_CarCount: '0', //平台总卡数
        find_CarCount_jh: '0', //激活
        find_CarCount_wjh: '0', //未激活
        find_CarCount_zy : '0', //在用
        find_CarCount_tj : '0', //停机
        today_orderCount: '0', //今日收款金额
        find_order_success: '0', //今日成功订单
        countNum: 0, //在网用户
        countFLow: 0, //在网用量
        averageFlow: 0, //平均用量
        find_Car: [], //平台总卡数 日 分组
        find_PackageRecharge: [], //套餐收款榜单\
        json :{},//所有数据集
        averageFlowList: {
          color: ['#ae465d','#ff345d'],
          digitalFlopStyle: {
            fontSize: 15,
            fill: '#2a3320'
          },
          showOriginValue:true,
          data:[
            {name:'在网用户',value:1},
            {name:'在网用量(TB)',value:1},
            {name:'平均用量(GB)',value:1},
          ],
          lineWidth: 10,
          radius:'85%'
        },
        quickList:[
          {name:'SIM 列表',path:'system/card',icon:'el-icon-bank-card'},
          {name:'客户列表',path:'system/agent_list',icon:'el-icon-s-custom'},
          {name:'卡池列表',path:'system/poolList',icon:'el-icon-odometer'},
          {name:'订单列表',path:'system/sysSucOrderList',icon:'el-icon-tickets'},
          {name:'返佣列表',path:'system/rabateList',icon:'el-icon-money'},
          {name:'套餐列表',path:'system/package_list',icon:'el-icon-present'},
        ],
        dataList:[
          {name:'销售总数',count:0},
          {name:'激活数量',count:0},
          {name:'尚未激活',count:0},
          {name:'在网数量',count:0},
          {name:'离网数量',count:0},
          {name:'今日收款',count:0},
        ],

      }
    },

    mounted: function () {
      let _this = this
      _this.loading=true
      _this.openNotice()
      _this.loginUser = JSON.parse(sessionStorage.getItem('loginUser'))
      _this.getIndexData(_this.getParameter())

    },
    methods: {
      selectNotice(notice){
        let _this=this
        _this.notice=notice
        _this.noticeVisible=true
      },
      openNotice() {
        let _this = this
        let notice = require("../../api/notice")
        notice.getNotice()
                .then(res => {
                  if (res.data.code === '0') {
                    let data= res.data.data
                    _this.notice = data[0]
                    _this.noticeData =data
                    let b = this.$route.path
                    if (b === '/welcome') {
                    }
                  }
                })
                .catch(err => {})
      },
      goPath(val){
        this.$router.push({
          path: val.path ,
          query:{
            type:val.type
          }
        })
      },
      /**
       * 站内信查询
       */
      openStationInfo() {
        let _this = this
        let mail=require('../../api/notice')
        mail.getMail().then(res => {
          if (res.data.code === '0') {
            _this.mail = res.data.data
          }
        })
        _this.infoDis = true
      },
      //获取第一行展示
      getFirstShow(){
        let _this=this
        let jsonobj =_this.json
        _this.find_CarCount = tools.formatNum(jsonobj.find_CarCount)//总卡数
        _this.find_CarCount_jh= tools.formatNum(jsonobj.find_CarCount_jh)
        _this.find_CarCount_wjh= tools.formatNum(jsonobj.find_CarCount_wjh)
        _this.find_CarCount_zy = tools.formatNum(jsonobj.find_CarCount_zy)
        _this.find_CarCount_tj = tools.formatNum(jsonobj.find_CarCount_tj)
        _this.today_orderCount = tools.formatNum(jsonobj.today_orderCount)

        _this.dataList= [
          {name:'销售总数',count:_this.find_CarCount,path:'system/card',type:'CarCount'},
          {name:'激活数量',count:_this.find_CarCount_jh,path:'system/card',type:'CarCount_jh'},
          {name:'尚未激活',count:_this.find_CarCount_wjh,path:'system/card',type:'CarCount_wjh'},
          {name:'在网数量',count:_this.find_CarCount_zy,path:'system/card',type:'CarCount_zy'},
          {name:'离网数量',count:_this.find_CarCount_tj,path:'system/card',type:'CarCount_tj'},
          {name:'今日收款',count:_this.today_orderCount,path:'system/sysSucOrderList',type:'today_orderCount'},
        ]
      },

      getTwoShow(){
        let that=this
          let jsonobj =that.json
          that.averageFlowList.data=[]
          that.averageFlowList.data.push(
                  {name: '在网用户', value:parseInt(jsonobj.countNum)})
          that.averageFlowList.data.push(
                  {name: '在网用量(TB)', value:parseInt(jsonobj.countFLow)})
          that.averageFlowList.data.push(
                  {name: '平均用量(GB)', value: parseInt(jsonobj.averageFlow)})
          that.averageFlowList ={...that.averageFlowList}
      },

      getParameter() {
        let _this = this
        let map = _this.map
        map.startTime = tools.getBeforeDate(2)
        map.endTime = tools.gitData()
        map.agentId = _this.loginUser.agentId
        return map
      },
      getIndexData(map) {
        new Promise((resolve,reject)=>{
          let _this = this
          let data = require('../../api/welcome')
          data.getIndexDataTM(map).then(response=>{
            try {
              if (response.data.code === '0') {
                _this.$alert("恭喜您，已获取最新的数据")
                _this.loading = false
                _this.json  = JSON.parse(aesDecrypt(response.data.data))
                let jsonobj = _this.json
                _this.loading=false

                _this.find_order_success = tools.formatNum(jsonobj.find_order_success)
                _this.find_order_price = tools.formatNum(jsonobj.find_order_price)

                _this.find_Car = jsonobj.find_Car
                _this.find_zwList = jsonobj.zwList
                _this.countNumTM_useFlow = jsonobj.countNumTM_useFlow

                _this.getFirstShow()
                _this.getTwoShow()
              }
            } finally {
              _this.loading=false
            }
          })

        })

      },


      isRefresh(internal){
        let timer=sessionStorage.getItem("refreshTimer")
        let now= new Date().getTime()
        if(now - timer < internal){
          return false
        }else{
          timer = now
          sessionStorage.setItem("refreshTimer",timer)
          return true
        }
      }
    }
  }
</script>


<style scoped>
  .dot:after{
    content: "";
    display: block;
    width:6px;
    height:6px;
    background-color: #4a72b8;
    border-radius: 50%;
  }
  .dot {
    padding: 10px;
    border-radius: 8px;
  }

  ::v-deep .dv-active-ring-chart .active-ring-info .dv-digital-flop{
  }

  ::v-deep .dv-active-ring-chart .active-ring-info .active-ring-name{
    color: #2a3320;
    font-weight: 300;
    text-overflow: initial;
    overflow: inherit;

  }

  ::v-deep .dv-active-ring-chart .active-ring-info{
    display: block;
    color: #2a3320;
    left: -50%;
  }

  >>> .el-card__body{
    overflow-x: auto;
  }
  >>>  .el-card__body::-webkit-scrollbar {
    height: 10px;
  }
  >>>  .el-card__body::-webkit-scrollbar-thumb {
    background-color: white;
  }

  >>>  .el-card__body::-webkit-scrollbar-thumb:hover {
    background-color: #333333;
  }
</style>

<style scoped lang="less">

  .center-data-el-col::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .center-data-el-col::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);
  }
  .center-data-el-col::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }
  .pieecharts::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .pieecharts::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: #fff;
    background-image: #fff;
  }
  .pieecharts::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #fff;
    border-radius: 10px;
  }

</style>
<style lang="less" scoped>
  /deep/.el-table td,
  .el-table th {
    padding: 0px;
  }
</style>
<style lang="less">
  .el-table td,
  .el-table th {
    padding: 0px !important;
  }
  thead.has-gutter {
    height: 40px;
  }

  .flg {
    //width: 180px;
    height: 100px;
    background: white;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    position: relative;
    z-index: 90;
  }
  .flg .flg-con{
    width: 85px;
    height: 88px;
    overflow: hidden;
    position: absolute;
    top: -3px;
    right: -3px;
  }
  .flg .flg-text {
    color: white;
    text-align: center;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    position: relative;
    padding: 2px 0;
    left: 25px;
    top: 10px;
    width: 80px;
    background-color: red;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#BFDC7A), to(#8EBF45));
    background-image: -webkit-linear-gradient(top, #BFDC7A, #8EBF45);
    background-image: -moz-linear-gradient(top, #BFDC7A, #8EBF45);
    background-image: -ms-linear-gradient(top, #BFDC7A, #8EBF45);
    background-image: -o-linear-gradient(top, #BFDC7A, #8EBF45);
    -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
  }
  .flg .flg-text:before, .box-text:after {
    content: "";
    position: absolute;
    bottom: -3px;
  }
  .flg .flg-text:before {
    left: 0;
  }
  .flg .flg-text:after {
    right: 0;
  }


</style>
